interface NavConfigItem {
  match?: string;
  props?: { link?: string; isCustomActive?: boolean };
}

// Which nav item owns the selection (active styling + notch) for a route.
// `isCustomActive` lets an item stay selected across routes its link doesn't
// cover (Jobs on /requisitions), so the notch and the active row never disagree
// when switching the Jobs/Requisitions tabs.
export const isNavItemActive = (
  item: NavConfigItem,
  pathname: string
): boolean => {
  if (item?.props?.isCustomActive) return true;
  const link = item?.props?.link || item?.match;
  return Boolean(link) && pathname.startsWith(link as string);
};
